export default "__VITE_ASSET__DypiYOaC__"